"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoContent = void 0;
var video_content_element_1 = __importDefault(require("./video-content.element"));
var video_content_component_1 = __importDefault(require("./video-content.component"));
var video_content_1 = __importDefault(require("./video-content"));
var chapter_1 = __importDefault(require("./chapter"));
// TODO: use common.appendMessageElement() to append the alert
//  OR move to a custom bootstrap module and then import it here
//  functions to move: createAlertElement, displayAlert
var createAlertElement = function (message) {
    var alertElement = document.createElement('div');
    alertElement.classList.add('alert');
    alertElement.classList.add('alert-danger');
    alertElement.classList.add('alert-dismissible');
    alertElement.setAttribute('role', 'alert');
    var buttonElement = document.createElement('button');
    buttonElement.type = 'button';
    buttonElement.classList.add('close');
    buttonElement.dataset.dismiss = 'alert';
    buttonElement.setAttribute('aria-label', 'Close');
    var closeElement = document.createElement('span');
    closeElement.setAttribute('aria-hidden', 'true');
    closeElement.innerHTML = '&times;';
    buttonElement.prepend(closeElement);
    var messageElement = document.createElement('p');
    messageElement.innerHTML = message;
    alertElement.append(buttonElement);
    alertElement.append(messageElement);
    return alertElement;
};
var displayAlert = function (message, element, elementSelector) {
    if (elementSelector === void 0) { elementSelector = '.container'; }
    var alertElement = createAlertElement(message);
    var appendTo = document.querySelector(elementSelector);
    if (element instanceof HTMLElement) {
        appendTo = element;
    }
    if (appendTo !== null) {
        appendTo.append(alertElement);
    }
};
/**
 * App element selector
 */
var elementSelector = 'video-content';
var appErrors = [];
/**
 * Display all errors at once
 */
var displayErrors = function () {
    if (appErrors.length === 0) {
        return false;
    }
    appErrors.forEach(function (error) {
        displayAlert(error.message);
    });
};
var init = function () {
    // Define a new custom element
    window.customElements.define(elementSelector, video_content_element_1.default);
    // customElements
    //     .whenDefined('temp-content')
    //     .then(() => {});
    var components = document.querySelectorAll(elementSelector);
    if (components.length === 0) {
        return false;
    }
    // Count the components
    console.log("'".concat(elementSelector, "' components found: ").concat(components.length));
    var getTitle = function (videoContentElement) {
        var videoTitleElement = videoContentElement.querySelector('.video-title');
        var videoTitle = '';
        if (videoTitleElement !== null) {
            videoTitle = videoTitleElement.innerText;
        }
        return videoTitle;
    };
    var getChapters = function (videoContentElement) {
        var chapterElements = videoContentElement.querySelectorAll('.video-chapter');
        var chapters = [];
        var pushChapter = function (chapterElement) {
            var secondsElement = chapterElement.querySelector('.video-chapter-seconds');
            var seconds = 0;
            if (secondsElement !== null) {
                seconds = parseInt(secondsElement.innerText);
            }
            var titleElement = chapterElement.querySelector('.video-chapter-title');
            var title = '';
            if (titleElement !== null) {
                title = titleElement.innerText;
            }
            chapters.push(new chapter_1.default(title, seconds));
        };
        chapterElements.forEach(pushChapter);
        return chapters;
    };
    var loadVideoContent = function (videoContentElement, index) {
        var videoTitle = getTitle(videoContentElement);
        var chapters = getChapters(videoContentElement);
        var videoUrl = videoContentElement.videoUrl;
        if (typeof videoUrl === 'undefined') {
            var newVideoUrl = videoContentElement.getAttribute('video-url');
            videoUrl = newVideoUrl !== null ? newVideoUrl : '';
        }
        var layout = videoContentElement.layout;
        if (typeof layout === 'undefined') {
            var newLayout = videoContentElement.getAttribute('layout');
            layout = newLayout !== null ? newLayout : '';
        }
        var authors = videoContentElement.authors;
        if (typeof authors === 'undefined') {
            var newAuthors = videoContentElement.getAttribute('authors');
            authors = newAuthors !== null ? newAuthors : '';
        }
        var references = videoContentElement.references;
        if (typeof references === 'undefined') {
            var newReferences = videoContentElement.getAttribute('references');
            references = newReferences !== null ? newReferences : '';
        }
        var videoContent = new video_content_1.default(index, videoUrl, layout, videoTitle, authors, references, chapters);
        // TODO: Refactor so that the rendered content can be used instead or re-rendering it
        videoContentElement.innerHTML = '';
        var videoComponent = new video_content_component_1.default(videoContent, videoContentElement);
        videoComponent.load();
    };
    var tryCatchOnLoad = function (videoContentElement, index) {
        try {
            loadVideoContent(videoContentElement, index);
        }
        catch (error) {
            var heading = "Error in ".concat(elementSelector, " number ").concat((index + 1), ":");
            var message = "<strong>".concat(heading, "</strong> <br> ").concat(error.message);
            displayAlert(message, videoContentElement);
            return false;
        }
        return true;
    };
    components.forEach(tryCatchOnLoad);
};
// Document Ready
// window.addEventListener('DOMContentLoaded', runApp);
exports.videoContent = {
    init: init,
};
